import { Component, OnChanges, EventEmitter, Input, Output, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { PhBhpFilterComponent } from '../ph-bhp-filter/ph-bhp-filter.component';
import { PHBHPFeaturePackageEvaluationService } from '../ph-bhp-feature-package-evaluation.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PhBhpViewSopobserveComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopobservation/public_api';
import { SopDetail } from '../Models/SopDetail';
import { DatePipe } from '@angular/common'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs/Subscription';
import { PHBHPFeaturePackageEvaluationFilterService } from '../ph-bhp-feature-package-evaluationfilter.service';
import { Subject } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';
import { TranslateService } from '@ngx-translate/core';
import { PhBhpSopObservePdfExportComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopobservation/lib/ph-bhp-sop-observe-pdf-export/ph-bhp-sop-observe-pdf-export.component';

@Component({
  selector: 'lib-ph-bhp-sop-individual-overview',
  templateUrl: './ph-bhp-sop-individual-overview.component.html',
  styleUrls: ['./ph-bhp-sop-individual-overview.component.css'],
  providers: [DatePipe]
})
export class PhBhpSopIndividualOverviewComponent implements OnChanges, OnDestroy {
  subscription: Subscription;
  isSavedFromEvaluation: boolean;
  complianceType;
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal;
  @Input() userData;
  @Input() filterDetails
  @Input() isDesktop = true;
  @Output() childData = new EventEmitter();
  @ViewChild('filter') filter: PhBhpFilterComponent;
  @ViewChild('multiselect') multiselect: any;
  noDataFound: boolean = false;
  showProfessionalSubcategory: boolean = true;
  gridGroupable = true;
  sopDetail: SopDetail[];
  tempSopDetail: SopDetail[];
  sopiDs: Array<any> = [];
  gridData: Array<any>;
  institutionsList: Array<any>;
  institutionSubject = new Subject<boolean>();
  chart;
  userID;
  data;
  roleId;
  deleteData;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  isSelectable = true;
  deleteSelectionText: string = '';
  @ViewChild('gridTable') gridTable;
  @ViewChild('deleteSelectionModal') deleteSelectionModal;
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;

  fields: Array<any> = [
    { 'field': 'createdDataTime', 'title': 'EVALUATION.DATE' },
    { 'field': 'institutionName', 'title': 'EVALUATION.INSTITUTION' },
    { 'field': 'departmentName', 'title': 'EVALUATION.DEPARTMENT' },
    { 'field': 'wardName', 'title': 'EVALUATION.WARD' },
    { 'field': 'userName', 'title': 'EVALUATION.USER' },
    { 'field': 'professsionalCategory', 'title': 'EVALUATION.PROFESSIONAL_CATEGORY' },
    { 'field': 'professionalSubCategory', 'title': 'EVALUATION.PROFESSIONAL_SUB_CATEGORY' },
    { 'field': 'sopName', 'title': 'EVALUATION.SOP' },
    { 'field': 'createdByName', 'title': 'OBSERVATION.CREATED_BY' }
  ];

  actionItems: any = [
    { name: 'SOP_MANAGEMENT.VIEW_SOP', imgSrc: 'assets/ph-bhp-layout/svg/icon-view.svg', onClick: (dataItem) => { this.viewOpobserve(dataItem) } },
    { name: 'EVALUATION.DOWNLOAD_SOP_OBSERVATION', imgSrc: 'assets/ph-bhp-layout/svg/download-icon-blue.svg', onClick: (dataItem) => { this.openDownloadSOPModal(this.downloadSOPModal, dataItem) } },
    { name: 'LAYOUT_MODULE.DELETE', imgSrc: 'assets/ph-bhp-layout/svg/icon-delete.svg', onClick: (dataItem) => { this.openDeleteModal(this.delmodal, dataItem) } },

  ];
  horizontalAction = true;
  pageInfo = {
    items: 'EVALUATION.OBSERVATIONS',
    itemsPerPageLabel: 'EVALUATION.PER_PAGE.OBSERVATIONS'
  };
  formdata: { ward: { wardName: any; }; department: { departmentName: any; }; category: { categoryName: any; }; subCategory: { subCategoryName: any; }; creationDate: any; };
  pageTitle = 'EVALUATION.OVERVIEW_INDIVIDUAL_DATA_1';
  appName = 'MHS';
  public clickExcelBtn = false;
  evaluationLoaded: boolean = false;
  sopData;
  @ViewChild('downloadSOPModal') downloadSOPModal;
  selectedFormat: 'image' | 'pdf' = 'pdf';
  isEvaluationTable: boolean = true;

  constructor(
    private service: PHBHPFeaturePackageEvaluationService,
    public datepipe: DatePipe,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    private service2: PHBHPFeaturePackageEvaluationFilterService,
    public translate: TranslateService
    ) {
    this.gridGroupable = this.isDesktop;
  }

  initComponent(isNewFilter = false) {
    this.layoutService.showLoader = true;
    if (this.userData) {
      this.userID = this.userData.userId;
      this.roleId = this.userData.roleName.roleId
      if (!isNewFilter ) {
        this.getIndividualDataOverview(this.userID, this.roleId);
      }

      this.subscription = this.layoutService.lang.asObservable().subscribe(selectedLang => {
        if (this.data == undefined) {
          this.getIndividualDataOverview(this.userID, this.roleId)
        }
        else {
          this.getObservationsFilterByIndividualOverview(this.userID, this.data)
        }
      });

      if (isNewFilter) {
        this.evaluate(true);
      }
    }
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.service.getSOPDetails(this.userData.userId).subscribe((res: Array<SopDetail>) => {
      this.tempSopDetail = JSON.parse(JSON.stringify(res));
      this.sopDetail = res;
      this.sopDetail = this.sopDetail.sort((a, b) => this.compareSOPTitles(a, b));
      this.service.getUserHasSOPEvaluationFilter(this.userData.userId, 'Overview Individual data').subscribe((userHasFilter: boolean) => {
        this.isUserFilterSetted = true;
        this.userHasFilter = userHasFilter;
        if (this.userHasFilter) {
          setTimeout(() => { this.initComponent(); });
        } else {
          this.noDataFound = true;
          this.filter.showFilter();
          // Inicializar filterName por defecto
          this.filter.setFilterNameFilter(this.layoutService.translateText('EVALUATION.FILTER') + ' 1', true);
        }
      }, (error) => { }, () => { this.layoutService.showLoader = false; });
    });

  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  emitData(valve) {
    this.childData.emit(valve)
  }

  changeLangPage() {
    this.gridData.forEach((value, index) => {
      if (this.gridData[index].departmentName && this.gridData[index].professionalSubCategory && this.gridData[index].professsionalCategory && this.gridData[index].sopName)
        this.gridData[index].professionalSubCategory = this.layoutService.translateText(value.professionalSubCategory);
      this.gridData[index].professsionalCategory = this.layoutService.translateText(value.professsionalCategory);
      this.gridData[index].sopName = this.layoutService.translateText(value.sopName);
      this.gridData[index].departmentName = this.layoutService.translateText(value.departmentName);
    });
  }

  evaluate(flag) {
    if (!this.userHasFilter) {
      this.userHasFilter = true;
      this.isUserFilterSetted = true;
      this.layoutService.showLoader = true;
      setTimeout(() => { this.initComponent(true); }, 1000);
      return;
    }

    this.evaluationLoaded = false;
    this.userID = this.userData.userId;
    this.data = {
      sopiDs: "",
      filter: {
        startDate: this.filter.range.start,
        endDate: this.filter.range.end,
        instutionIDs: "",
        departmentID: "",
        wardID: "",
        professionalCategoryID: "",
        subprofessionalCategoryID: "",
        countryID: 0,
        filterName: this.filter.filterName || this.layoutService.translateText('EVALUATION.FILTER') + ' 1'
      },
      roleId: this.userData.roleName.roleId

    }
    if (this.userData.roleName.roleId == 1 && this.filter.setCountry != 0) {
      this.data.filter.countryID = this.filter.setCountry.countryID
    }
    // if (this.sopiDs == "") {
    //   this.sopDetail.forEach((sop) => {
    //     this.data.sopiDs += sop.sopid + ","
    //   })
    //   this.data.sopiDs = this.data.sopiDs.slice(0, -1);
    // }

    if (this.sopiDs.length == 0) {
      this.sopDetail.forEach((sop) => {
        this.data.sopiDs += sop.sopid + ","
      })
      this.data.sopiDs = this.data.sopiDs.slice(0, -1);
    } else {
      var sop = this.sopiDs;
      sop.forEach(element => {
        this.data.sopiDs += element.sopid + ","
      });
      this.data.sopiDs = this.data.sopiDs.slice(0, -1);
    }

    this.data.filter = this.filter.assignData(this.data.filter);

    if (flag == true) {
      this.getObservationsFilterByIndividualOverview(this.userID, this.data);
    }
    else if (flag == false) {
      this.saveObservationsFilterByIndividualOverview(this.userID, this.data);
    }

  }

  openDeleteModal(mode, data) {
    this.deleteData = data;
    this.modalRef = this.modalService.show(mode, Object.assign({}, { class: 'w-420' }));
  }

  delete() {
    this.deleteData

    this.service.deleteObservation(this.deleteData.observationID, this.userID).subscribe((res) => {

      if (this.data == undefined) {
        this.getIndividualDataOverview(this.userID, this.roleId)
      } else {
        this.getObservationsFilterByIndividualOverview(this.userID, this.data);
      }
    })
  }

  compareSOPTitles(a, b) {
    var aTitleTranslated = this.getSOPTranslation(a.title);
    var bTitleTranslated = this.getSOPTranslation(b.title);
    if (aTitleTranslated < bTitleTranslated) return -1;
    if (aTitleTranslated > bTitleTranslated) return 1;
    return 0;
  }

  getSOPTranslation(sopTrlID) {
    return this.layoutService.translateText(sopTrlID, '');
  }

  async addAdditionalColumns(res: any) {
    var hasProfessionalSubCategoryEnabled = false;
    var userRoleId = this.userData.roleName.roleId;
    this.fields = [
      { 'field': 'createdDataTime', 'title': 'EVALUATION.DATE' },
      { 'field': 'institutionName', 'title': 'EVALUATION.INSTITUTION' },
      { 'field': 'departmentName', 'title': 'EVALUATION.DEPARTMENT' },
      { 'field': 'wardName', 'title': 'EVALUATION.WARD' },
      { 'field': 'professsionalCategory', 'title': 'EVALUATION.PROFESSIONAL_CATEGORY' },
      { 'field': 'sopName', 'title': 'EVALUATION.SOP' },
      { 'field': 'createdByName', 'title': 'OBSERVATION.CREATED_BY' }
    ];

    if (!res || res.length == 0) return;
    var institutionIds = Array.from(new Set(res.map(item => item.institutionID)));
    for (let i = 0; i < institutionIds.length; i++) {
      var institutionId = institutionIds[i];
      var institutionConfig = await this.service.getConfigDetails(institutionId).first().toPromise();
      if (!hasProfessionalSubCategoryEnabled && institutionConfig.enableProfessionalSubCategory) {
        hasProfessionalSubCategoryEnabled = true;
        break;
      }
    }

    if (hasProfessionalSubCategoryEnabled) {
      const professionalCategoryIndex = this.fields.findIndex(field => field.field === 'professsionalCategory') + 1;
      const professionalSubCategoryColumn = { 'field': 'professionalSubCategory', 'title': 'EVALUATION.PROFESSIONAL_SUB_CATEGORY' };
      this.fields = [...this.fields.slice(0, professionalCategoryIndex), professionalSubCategoryColumn, ...this.fields.slice(professionalCategoryIndex)];
    }

    if (userRoleId == 1 || userRoleId == 2) {
      const wardNameIndex = this.fields.findIndex(field => field.field === 'wardName') + 1;
      const userNameColumn = { 'field': 'userName', 'title': 'EVALUATION.USER' };
      this.fields = [...this.fields.slice(0, wardNameIndex), userNameColumn, ...this.fields.slice(wardNameIndex)];
    }

    if (userRoleId == 1) {
      const countryColumn = { 'field': 'countryName', 'title': 'AUTHORIZATION.COUNTRY' };
      this.fields.push(countryColumn);
    }
  }

  getIndividualDataOverview(userID, roleID) {
    this.layoutService.showLoader = true;
    this.service.getIndividualDataOverview(userID, roleID, this.userData.country, this.translate.currentLang).subscribe(async (res: any) => {
      let that = this;
      this.gridTable.clearSelection();
      await this.addAdditionalColumns(res.sopIndividualDataList);
      this.gridData = res.sopIndividualDataList.map(item => this.manageGrid(item, that));
      this.layoutService.showLoader = false;
      if (this.gridData !== null) {
        this.changeLangPage();
      }
      if (res.sopIndividualDataList == null) {
        this.noDataFound = true;
      } else {
        if (res.sopIndividualDataList.length == 0) {
          this.noDataFound = true;
        } else {
          this.noDataFound = false;
        }
        var filter = res.individualOverviewFilters;
        if (filter[0].sopiDs != "") {
          this.service.getSOPDetails(userID).subscribe((res: Array<SopDetail>) => {
            var sopDetail = res;
            var SOParray = [];
            var array = filter[0].sopiDs.split(',');
            if (sopDetail.length !== array.length) {
              array.forEach(function (item) {
                var title = sopDetail.find(x => x.sopid === parseInt(item))?.title || '';
                SOParray.push({ title: title, sopid: parseInt(item) })
              });
            }
            this.sopiDs = SOParray;
          });
        }
        if (filter && filter.length > 0) {
          // Inicializar filterName si no existe
          if (!filter[0].filter.filterName || filter[0].filter.filterName.trim() === "") {
            filter[0].filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' 1';
          }

          let startDate = new Date(filter[0].filter.startDate);
          startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
          let endDate = new Date(filter[0].filter.endDate);
          endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
          this.filter.dateRange = [startDate, endDate];
          this.filter.selectDate();
          this.filter.setFilterNameFilter(filter[0].filter.filterName, true);
          this.filter.setCountryFilter(filter[0].filter.countryID, filter[0].filter.instutionIDs, filter[0].filter.wardID, true);
          this.filter.setInstitutionsByID(filter[0].filter.instutionIDs, true);
          if (this.filter.wardListLoaded && this.filter.wardListLoaded.length > 0) {
            this.filter.onWardChange(this.filter.wardListLoaded.find(x => x.wardID == filter[0].filter.wardID));
          }

          this.filter.setDepartmentFilter(filter[0].filter.departmentID, true);
          this.filter.setDepartmentTypeFilter(filter[0].filter.departmentTypeID, true);
          // this.filter.setWardfilter(filter[0].filter[0].wardID,filter[0].filter[0].instutionIDs)
          this.filter.setProfessionalCategory(filter[0].filter.professionalCategoryID, filter[0].filter.SubprofessionalCategoryID, true)
        }
      }
      //this.changeLangPage();
      this.evaluationLoaded = true;
    })
  }

  getObservationsFilterByIndividualOverview(userID, data) {
    this.complianceType = "Overview Individual data";
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.service.getObservationsFilterByIndividualOverview(userID, this.isSavedFromEvaluation, this.userData.country, this.translate.currentLang, this.complianceType, data).subscribe(async (res: Array<any>) => {
      let that = this;
      this.gridTable.clearSelection();
      await this.addAdditionalColumns(res);
      this.gridData = res.map(item => this.manageGrid(item, that));
      if (this.gridData == null || (this.gridData !== null && this.gridData.length == 0)) {
        this.noDataFound = true;
      } else {
        this.noDataFound = false;
      }
      this.layoutService.showLoader = false;
      this.evaluationLoaded = true;
      if (this.gridData !== null) {
        this.changeLangPage();
      }
    });
  }
  saveObservationsFilterByIndividualOverview(userID, data) {
    this.complianceType = "Overview Individual data";
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.service.getObservationsFilterByIndividualOverview(userID, this.isSavedFromEvaluation, this.userData.country, this.translate.currentLang, this.complianceType, data).subscribe((res: Array<any>) => {
      this.layoutService.showLoader = false;
      //this.gridData = res
      // this.changeLangPage();
    });
  }

  viewOpobserve(observe) {
    this.formdata = {
      ward: { wardName: observe.wardName },
      department: { departmentName: observe.departmentName },
      category: { categoryName: observe.professsionalCategory },
      subCategory: { subCategoryName: observe.professionalSubCategory },
      creationDate: observe.createdDataTime
    }

    var initialState = {
      isDesktop: true,
      userData: this.userData,
      formdata: this.formdata,
      sopStep: JSON.parse(observe.sopVersionStep),
      comments: JSON.parse(observe.observationComments),
      seletedSteps: JSON.parse(observe.observedJson),
      clickNoSterility: observe.noSterility,
      sopName: observe.sopName,
      sopDescription: observe.sopDescription,
      isOverviewIndividual: true,
    };

    if (this.isDesktop) {
      this.modalRef = this.modalService.show(PhBhpViewSopobserveComponent, { initialState, class: 'modal-full w-full' });
    } else {
      this.childData.emit({ data: initialState, key: 'viewSop' });
    }
    // this.modalRef.content.action.subscribe((value) => {

    // });
  }

  openDownloadSOPModal(modal, data) {
    this.sopData = data;
    this.modalRef = this.modalService.show(modal, Object.assign({}, { class: 'w-420' }));
  }

  downloadSOP() {
    this.formdata = {
      ward: { wardName: this.sopData.wardName },
      department: { departmentName: this.sopData.departmentName },
      category: { categoryName: this.sopData.professsionalCategory },
      subCategory: { subCategoryName: this.sopData.professionalSubCategory },
      creationDate: this.sopData.createdDataTime
    }

    var initialState = {
      isDesktop: true,
      isDownload: true,
      format: this.selectedFormat,
      userData: this.userData,
      formdata: this.formdata,
      sopStep: JSON.parse(this.sopData.sopVersionStep),
      comments: JSON.parse(this.sopData.observationComments),
      seletedSteps: JSON.parse(this.sopData.observedJson),
      clickNoSterility: this.sopData.noSterility,
      sopName: this.sopData.sopName,
      sopDescription: this.sopData.sopDescription,
      predefinedComments: [],
    };


    this.service.getPredefinedComments().subscribe((predefinedComments) => {
      initialState.predefinedComments = predefinedComments;

      if (this.isDesktop) {
        this.modalRef = this.modalService.show(PhBhpSopObservePdfExportComponent, { initialState, class: 'modal-full w-full dissapear' });
      } else {
        this.childData.emit({ data: initialState, key: 'viewSop' });
      }
    });


  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    if (value === 'excel') {
      this.clickExcelBtn = false;
    }
  }

  manageGrid(sop, that) {
    let lang = localStorage.getItem('selectedlanguage');
    if (sop.createdDataTime) {
      const date1 = this.layoutService.convertUTCDateToLocalDate(sop.createdDataTime);
      sop.createdDataTime = date1.toLocaleDateString(lang, { month: '2-digit', day: '2-digit', year: 'numeric' })
    }
    return sop;
  }

  showSubCategories(showSubCategories: boolean) {
    if (showSubCategories) {
      this.fields = [
        { 'field': 'createdDataTime', 'title': 'EVALUATION.DATE' },
        { 'field': 'institutionName', 'title': 'EVALUATION.INSTITUTION' },
        { 'field': 'departmentName', 'title': 'EVALUATION.DEPARTMENT' },
        { 'field': 'wardName', 'title': 'EVALUATION.WARD' },
        { 'field': 'professsionalCategory', 'title': 'EVALUATION.PROFESSIONAL_CATEGORY' },
        { 'field': 'professionalSubCategory', 'title': 'EVALUATION.PROFESSIONAL_SUB_CATEGORY' },
        { 'field': 'sopName', 'title': 'EVALUATION.SOP' },
        { 'field': 'createdByName', 'title': 'OBSERVATION.CREATED_BY' }
      ];
    } else {
      this.fields = [
        { 'field': 'createdDataTime', 'title': 'EVALUATION.DATE' },
        { 'field': 'institutionName', 'title': 'EVALUATION.INSTITUTION' },
        { 'field': 'departmentName', 'title': 'EVALUATION.DEPARTMENT' },
        { 'field': 'wardName', 'title': 'EVALUATION.WARD' },
        { 'field': 'professsionalCategory', 'title': 'EVALUATION.PROFESSIONAL_CATEGORY' },
        { 'field': 'sopName', 'title': 'EVALUATION.SOP' },
        { 'field': 'createdByName', 'title': 'OBSERVATION.CREATED_BY' }
      ];
    }
  }

  showDeleteSelectionModal() {
    var selectedRows = this.gridTable.getSelectedRows();
    this.deleteSelectionText = this.layoutService.translateText('ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD_SELECTION');
    this.deleteSelectionText = this.deleteSelectionText.replace('{0}', selectedRows.length.toString());
    if (selectedRows.length > 0) {
      this.modalRef = this.modalService.show(this.deleteSelectionModal, Object.assign({}, { class: 'w-420' }));
    } else {
      this.layoutService.showWarning(this.layoutService.translateText('ERROR_MESSAGES.REQUIRED.NO_RECORD_SELECTED'));
    }
  }

  deleteSelection() {
    var selectedRows = this.gridTable.getSelectedRows();
    var observationIds = selectedRows.map(row => row.observationID);
    this.layoutService.showLoader = true;
    this.service.deleteObservations(observationIds, this.userData.userId).subscribe(res => {
      this.gridTable.clearSelection();
      this.evaluate(true);
    }, error => { this.layoutService.showLoader = false; });
  }

  resetFilters() {
    this.resetSOPFilter();
    this.filter.resetFilter();
    this.layoutService.showLoader = true;
    setTimeout(() => { this.evaluate(true); }, 1500);
  }

  onFilterSaved() {
    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  openFilter() {
    this.filter.showFilter();
  }

  resetSOPFilter(isMultifilter: boolean = false) {
    this.multiselect.reset();
    this.sopiDs = [];
    if (isMultifilter) {
      this.layoutService.showLoader = true;
      this.evaluate(true);
    }
  }

  onMultiselectChange(event: Event) {
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }
}
